// Cómo se llaman las cosas según el tipo de cuenta.
//
// LA TENSIÓN QUE ESTO RESUELVE, dicha en voz alta. La Doctrina 2 exige
// consistencia: «es *producto* en todo el sistema, no artículo ni ítem».
// Y tiene razón — dentro de una empresa. Pero quien inventaría su casa no
// tiene «productos de venta» ni «activos»: tiene cosas que se acaban y
// cosas que se quedan. Llamarle «tipo de inventario VENTA» a la despensa
// es exactamente la jerga que la Doctrina 2 prohíbe en la regla anterior.
//
// Así que la consistencia se mantiene DENTRO de cada tipo de cuenta, que
// es donde importa: una persona nunca ve las dos palabras para la misma
// cosa. Lo que cambia es el diccionario, no el modelo — en la base sigue
// siendo `tipo_inventario`, y el día que alguien mire el kárdex de una
// empresa y de una casa verá el mismo dato.
//
// NO SE TRADUCE LO QUE NO CAMBIA DE SIGNIFICADO. «Escanear» es escanear
// en los dos sitios; inventar sinónimos por adornar solo confunde a quien
// pide ayuda por teléfono.

const EMPRESA = {
  productos: 'Productos',
  activos: 'Activos',
  almacen: 'Almacén',
  existencias: 'Existencias',
  miTrabajo: 'Mi trabajo',
  // R-TIT-1 (20 sep 2026): «Tablero» no dice qué es; «Cómo va el negocio» sí.
  tablero: 'Cómo va el negocio',
  // Cómo se nombra cada tipo al hablar de UNA cosa.
  unProducto: 'producto',
  unActivo: 'activo',
  unLugar: 'ubicación',
};

const PERSONAL = {
  // Lo que se acaba y hay que reponer: comida, jabón, pilas.
  productos: 'Consumibles',
  // Lo que se queda: el taladro, la bici, la consola.
  activos: 'Pertenencias',
  // En una casa no hay «almacén»: hay sitios donde guardas cosas.
  almacen: 'Lugares',
  existencias: 'Dónde está cada cosa',
  miTrabajo: 'Mi casa',
  tablero: 'Resumen',
  unProducto: 'consumible',
  unActivo: 'pertenencia',
  unLugar: 'lugar',
};

export function vocabulario(esEmpresa) {
  return esEmpresa ? EMPRESA : PERSONAL;
}

// Las dos claves existen en los dos diccionarios, o una pantalla acabaría
// pintando `undefined` en una cuenta y el nombre bueno en la otra. Se
// comprueba en una prueba, no aquí: esto no es sitio para lanzar.
export const CLAVES = Object.keys(EMPRESA);
export const DICCIONARIOS = { EMPRESA, PERSONAL };
